export default "__VITE_ASSET__DwD19Z4n__"